import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import { DataContext } from "../../../../app/providers/DataContext";
import { CONST_KEY_USUARIO_AUTENTICADO } from "../../../../app/constants/constanst-valores";

// Multi Sede Usuarios: selector múltiple de sedes (mismo patrón que
// GrupoUsuariosAgregarPage). La PRIMERA sede seleccionada es la primaria
// (TMUSE10.SedCod); todas se registran en el detalle TMUSE20.
import { obtenerFechaActual, obtenerLocalStorage } from "../../../../shared/utils/funciones";
import { useUsuarioFormEnvio } from "./useUsuarioFormEnvio";
import { useUsuarioFormCatalogos } from "./useUsuarioFormCatalogos";
import { useAccesosOrganizacion } from "./useAccesosOrganizacion";

// Estado y lógica de UsuarioFormPage. El orden de los hooks es el mismo que
// tenía la página: contexto, estados, ubicación, formulario, navegación
// (useUsuarioFormEnvio), longitud de documento y carga inicial
// (useUsuarioFormCatalogos).
export const useUsuarioForm = () => {

    const { listaTipoDocumento } = useContext(DataContext)

    const usuarioAutenticado = obtenerLocalStorage(CONST_KEY_USUARIO_AUTENTICADO)

    const rol = usuarioAutenticado?.tipo

    const [listaCompanias, setListaCompanias] = useState<any[]>([])
    const [listaSucursales, setListaSucursales] = useState<any[]>([])
    const [listaSedes, setListaSedes] = useState<any[]>([])

    // Multi Sede Usuarios: sedes elegidas [{value: SedCod, label: SedDesc}].
    // La primera es la sede primaria; el resto son sedes adicionales (TMUSE20).
    const [sedesSeleccionadas, setSedesSeleccionadas] = useState<any[]>([])
    const [errorSedes, setErrorSedes] = useState(false)

    const [, setMensaje] = useState('')
    const [, setMostrar] = useState(false)
    const [, setValorSeleccionado]=useState("")


    //Obtener la accion a partir de la url (agregar o editar)
    const location = useLocation();
    const pathname = location.pathname;

    const {usuario, compania,sucursal1,sede1} = location?.state || {}
    const accion = pathname.split("/").pop()
    const imagenbase = "/img/user.png"
    const { register, handleSubmit, watch, formState: { errors }, setValue } = useForm<any>({
        defaultValues: {
            usuario: usuario?.UseCod || "",
            num_ide: usuario?.UseIdeNro || "",
            nombre: usuario?.UseNom || "",
            ape_pat: usuario?.UseApePat || "",
            ape_mat: usuario?.UseApeMat || "",
            telefono: usuario?.UseTel || "",
            celular: usuario?.UseCel || "",
            sexo: usuario?.UseSex || "M",
            email_lab: usuario?.UseEmailLab || "",
            email: usuario?.UseEmail || "",
            // permiso: usuario?.UsePermi || "G",
            privilegio: usuario?.UsePriv || "N",
            fingreso: usuario?.UseFchIng || obtenerFechaActual(),
            fnacimiento: usuario?.UseFchNac || "",
            anexo: usuario?.UseAnex || "",
            ip: usuario?.UseIp || "",
            usuariokpc: usuario?.UseCod2 || "",
            clavekpc: usuario?.UsePsw2 || "",
            useridhuella: usuario?.UseIdHuell || "",
            area: usuario?.UseAre || "",
            direccion: usuario?.UseDir || "",
            ubigeo: usuario?.UseUbi || "",
            Imagen: "",
            estado: usuario?.UseEst || "A",
        },
    });


    const {
        obtenerSucursalesPorCompania,
        obtenerSedesPorSucursal,
        maxLengthInput,
        handleInputChange,
        cambiarTipoDocumento,
    } = useUsuarioFormCatalogos({
        usuarioAutenticado,
        rol,
        usuario,
        compania,
        accion,
        watch,
        setValue,
        setListaCompanias,
        setListaSucursales,
        setListaSedes,
        setSedesSeleccionadas,
        setValorSeleccionado,
    })

    // Modal "Accesos por organización" (compañía, sucursal, sedes y modo de acceso).
    const accesos = useAccesosOrganizacion({
        usuario,
        accion,
        token: usuarioAutenticado?.token,
        watch,
        setValue,
        listaCompanias,
        listaSucursales,
        listaSedes,
        sedesSeleccionadas,
        setSedesSeleccionadas,
        setErrorSedes,
        obtenerSucursalesPorCompania,
        obtenerSedesPorSucursal,
    })

    const { onSubmitCrear, onSubmitEditar, cancelar } = useUsuarioFormEnvio({
        sedesSeleccionadas,
        accesosOrg: accesos.accesosOrg,
        setErrorSedes,
        setMensaje,
        setMostrar,
        rol,
        usuarioAutenticado,
        usuario,
        sucursal1,
        sede1,
        accion,
        watch,
    })

    return {
        accesos,
        accion,
        imagenbase,
        handleSubmit,
        onSubmitCrear,
        onSubmitEditar,
        cancelar,
        register,
        errors,
        watch,
        listaCompanias,
        listaSucursales,
        listaSedes,
        listaTipoDocumento,
        sedesSeleccionadas,
        setSedesSeleccionadas,
        errorSedes,
        setErrorSedes,
        obtenerSucursalesPorCompania,
        obtenerSedesPorSucursal,
        cambiarTipoDocumento,
        handleInputChange,
        maxLengthInput,
        rol,
    }
}
